import React from 'react'
import styles from './EndToEnd.module.scss'

const contents = [
  {
    title: 'Manage',
    description: '監査イベント、DevOpsスコア、バリューストリーム管理等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsBarChartSteps.svg',
  },
  {
    title: 'Plan',
    description: 'イシュー管理、カンバンボード、エピック、ロードマップ、サービスデスク等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsCalendarEvent.svg',
  },
  {
    title: 'Create',
    description: 'ソースレコード管理、コードレビュー、Wiki、デザイン管理等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsJournalCode.svg',
  },
  {
    title: 'Verify',
    description: 'CI（Continuous Integration）、コード品質、統合テスト、Webパフォーマンス等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsListTask.svg',
  },
  {
    title: 'Package',
    description: 'コンテナレジストリ、パッケージレジストリ、依存関係プロキシ等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsCodeSlash.svg',
  },
  {
    title: 'Secure',
    description: 'SAST、DAST、依存関係スキャン、コンテナスキャン、ライセンスコンプライアンスチェック等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsShieldLock.svg',
  },
  {
    title: 'Release',
    description: 'CD（Continuous Delivery）、リリースオーケストレーション、アプリプレビュー等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsMegaphone.svg',
  },
  {
    title: 'Configure',
    description: 'Auto DevOps、Kubernetes設定、サーバーレス、GitOps（Infrastructure as Code）等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsGear.svg',
  },
  {
    title: 'Monitor',
    description: 'メトリクス、ロギング、トラッキング、クラスタモニタリング、インシデント管理等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsGraphUp.svg',
  },
  {
    title: 'Defend',
    description: 'WAF、脆弱性スキャン、コンテナスキャン、権限管理等',
    src: '/images/LP/LP202407/Icon/EndToEnd/BsGem.svg',
  },
]

const EndToEnd: React.FC = () => {
  const listItems = contents.map((item, i) => (
    <React.Fragment key={i}>
      <li>
        <div className={styles.icon}>
          <img src={item.src} alt="" />
        </div>
        <div className={styles.text}>
          <div className={styles.title}>{item.title}</div>
          <p className={styles.description}>{item.description}</p>
        </div>
      </li>
      {i < contents.length - 1 && <div className={styles.divider}></div>}
    </React.Fragment>
  ))
  return (
    <div className={styles.section}>
      <div className={styles.wrapper}>
        <div className={styles.section_title}>アプリケーションまたはSaaSで提供されるエンドツーエンドの機能</div>
        <ul className={styles.list}>{listItems}</ul>
      </div>
    </div>
  )
}
export default EndToEnd
